import type { ComponentProps } from 'react';

import { Separator } from '@change-corgi/design-system/components/content';
import { Html } from '@change-corgi/design-system/html';
import { Box } from '@change-corgi/design-system/layout';
import { Text } from '@change-corgi/design-system/typography';

import { EmbeddedMedia } from 'src/app/shared/components/embeddedMedia';

import { Actions } from './components/Actions';
import { ShareLinks } from './components/ShareLinks';
import { StarterActions } from './components/StarterActions';
import { usePageBody } from './hooks/usePageBody';

export function PageBody(props: ComponentProps<typeof Box>) {
	const {
		data: { description, creationDate, embeddedMedia },
	} = usePageBody();

	return (
		<Box {...props}>
			<Box>
				<Text color="neutral-grey700">{creationDate}</Text>
			</Box>
			<Html as="div" html={description} mt={16} breakWord data-qa="dm-response-description" />
			{embeddedMedia?.html && (
				<EmbeddedMedia
					html={embeddedMedia.html}
					aspectRatio={embeddedMedia.aspectRatio || undefined}
					mt={16}
					sx={{
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'&>iframe': {
							width: ['100%', 600],
						},
					}}
					data-qa="embedded-media"
				/>
			)}
			<Actions />
			<Separator my={24} />
			<ShareLinks />
			<StarterActions mt={32} />
		</Box>
	);
}
